import { Tab, Tabs } from "@mui/material";
import React from "react";

export default function SimpleTab({ tabs, value, setValue, sx }) {
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Tabs value={value} onChange={handleChange}>
      {tabs.map((tab, i) => {
        return <Tab key={i} wrapped label={tab} value={i} sx={sx} />;
      })}
    </Tabs>
  );
}
